<template>
  <div class="main progressMain">
    <!-- 顶部 -->
    <div class="title">
      <img class="blueCircle" src="../assets/blueCircle.png" />
      <span class="text">申请信息</span>
    </div>

    <!-- 内容主体 -->
    <div class="whiteBackground">
      <!-- 步骤条 -->
      <el-steps :active="active" align-center finish-status="success" class="steps">
        <el-step title="提交申请"></el-step>
        <el-step title="审核处理"></el-step>
        <el-step title="缴纳会费"></el-step>
        <el-step title="入会完成"></el-step>
      </el-steps>

      <div class="step-tip">
        <div class="pic">
          <img src="../assets/examine.png">
        </div>
        <p style="margin-top: 10px;margin-bottom: 30px;">审核中</p>
        <p class="red">您的入会申请资料已提交审核，协会将尽快进行审核。</p>
        <p class="red">如有问题可与协会联系，联系方式：64083368</p>
        <el-button type="primary" size="small" class="downloadBtn" @click="downloadPayNotice">
          <div class="btnContainer">
            <img src="../assets/download.png" style="width: 20px;margin-right: 5px;">
            <span class="text">缴费通知</span>
          </div>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import config from '../config'

const { downloadUrl } = config

export default {
  data () {
    return {
      downloadUrl: downloadUrl,
      active: 0,
      file: ''
    }
  },
  methods: {
    downloadPayNotice () {
      API.getJFTZ().then(resp => {
        if (resp.resultCode === '0000') {
          this.file = resp.data.file
          window.open(downloadUrl + this.file)
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.progressMain {
  .title {
    .text {
      margin-left: 0;
      color: #3778ff;
    }
    .blueCircle {
    vertical-align: middle;
    width: 30px;
    height: 30px;
    }
  }
  .whiteBackground {
    width: calc(100% - 10px);
    height: 100%;
    background: #fff;
    .steps {
      height: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .step-tip{
      text-align: center;
      margin-top: 50px;
      img{
        width: 90px;
      }
      .red{
        font-size: 18px;
        color: red;
        line-height: 32px;
      }
      .downloadBtn {
        margin-top: 50px;
        .btnContainer {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .text {
          font-size: 15px;
          margin: 0;
          color: #fff;
        }
      }
    }  
  }
}
</style>
